export const skills=[
    {
        skill:"C++"
    },
    {
     skill:"JavaScript"
    },
    {
        skill:"ReactJs"
    },
    {
        skill: "TailwindCSS"
    },
    {
        skill: "Java"
    },
    {
        skill:"Postgresql"
    },
    {
        skill:"Salesforce Admin"
    },
    {
        skill:"Firebase"
    }

]